export default {"src":"/_next/static/media/thief_64.35e5dc71.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};